// extracted by mini-css-extract-plugin
module.exports = {"root":"PlayerControls_root__Kfjqz"};